import { Link } from "react-router-dom";
import { Phone, MessageSquare, Facebook, Mail, Star } from "lucide-react";
import { BRAND } from "@/lib/brand";
import { TOP_SERVICES, servicePath } from "@/lib/services";

export default function Footer() {
  return (
    <footer className="bg-charcoal text-cream mt-0 border-t-2 border-charcoal" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 md:px-8 py-16 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="font-heading font-bold text-2xl">Skedaddle <span className="text-coral">Junk Removal</span></div>
          <p className="mt-3 font-body text-cream/70 max-w-sm">One call and it skedaddles! Fast, friendly junk hauling across the Lowcountry of South Carolina.</p>
          <div className="mt-5 flex flex-wrap gap-3">
            <a href={BRAND.phoneHref} className="inline-flex items-center gap-2 bg-coral text-cream font-heading font-bold rounded-full px-5 py-3 border-2 border-cream/20"><Phone className="w-4 h-4" /> {BRAND.phoneDisplay}</a>
            <a href={BRAND.smsHref} className="inline-flex items-center gap-2 bg-teal text-cream font-heading font-bold rounded-full px-5 py-3 border-2 border-cream/20"><MessageSquare className="w-4 h-4" /> Text us</a>
          </div>
          <p className="mt-4 font-body text-cream/60 text-sm">{BRAND.hours}</p>
          <a href={BRAND.emailHref} data-testid="footer-email" className="mt-1 inline-flex items-center gap-2 py-2 font-body text-cream/75 text-sm hover:text-sunny transition-colors"><Mail className="w-4 h-4" /> {BRAND.email}</a>
          <div className="mt-4 flex flex-wrap gap-3">
            {BRAND.reviewFbUrl && (
              <a href={BRAND.reviewFbUrl} target="_blank" rel="noreferrer" data-testid="footer-review-fb"
              className="inline-flex items-center gap-2 bg-[#1877F2] text-white font-heading font-bold rounded-full px-5 py-2.5 border-2 border-cream/20 hover:brightness-110 transition-all">
              <Facebook className="w-4 h-4" /> Review us on Facebook
            </a>
            )}
            {BRAND.reviewGoogleUrl && (
              <a href={BRAND.reviewGoogleUrl} target="_blank" rel="noreferrer" data-testid="footer-review-google"
                className="inline-flex items-center gap-2 bg-white text-charcoal font-heading font-bold rounded-full px-5 py-2.5 border-2 border-cream/20 hover:bg-cream transition-all">
                <Star className="w-4 h-4 fill-sunny text-sunny" /> Review us on Google
              </a>
            )}
          </div>
        </div>
        <div>
          <div className="font-heading font-semibold text-sunny mb-3">Services</div>
          <ul className="font-body text-cream/75 text-sm">
            {TOP_SERVICES.slice(0, 7).map((s) => (
              <li key={s.slug}><Link to={servicePath(s)} className="inline-block py-2 hover:text-sunny">{s.title}</Link></li>
            ))}
            <li><Link to="/services" className="inline-block py-2 hover:text-sunny font-semibold">See all services</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-heading font-semibold text-sunny mb-3">Company</div>
          <ul className="font-body text-cream/75 text-sm">
            <li><Link to="/about" className="inline-block py-2 hover:text-sunny">About</Link></li>
            <li><Link to="/service-areas" className="inline-block py-2 hover:text-sunny">Service Areas</Link></li>
            <li><Link to="/gallery" className="inline-block py-2 hover:text-sunny">Gallery</Link></li>
            <li><Link to="/give-back" className="inline-block py-2 hover:text-sunny">Give Back</Link></li>
            <li><Link to="/what-we-cant-haul" className="inline-block py-2 hover:text-sunny">What We Cannot Haul</Link></li>
            <li><Link to="/faq" className="inline-block py-2 hover:text-sunny">FAQ</Link></li>
            <li><Link to="/contact" className="inline-block py-2 hover:text-sunny">Get My Free Quote</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-cream/15">
        <div className="mx-auto max-w-7xl px-4 md:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-cream/55 font-body text-sm">
          <span>© {new Date().getFullYear()} Skedaddle Junk Removal. Serving the Lowcountry, SC.</span>
          <div className="flex gap-4">
            <Link to="/privacy" className="inline-block py-2 hover:text-sunny">Privacy</Link>
            <Link to="/terms" className="inline-block py-2 hover:text-sunny">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
